import Vue from 'vue'
import { ReviewsSummaryConfig as IReviewsSummaryConfig } from 'services/api-service'
import reviewsStore from 'store/reviews-store'
import reviewsSummaryConfig from 'widgets/reviews-summary/reviews-summary.config'

import withRender from './ratings-breakdown.html'
import './ratings-breakdown.scss'

const MIN_REVIEWS_FOR_FILTERING = 3

export default withRender((Vue as any).extend({
  data() { return { reviewsStore } },
  props: {
    ratingsBreakdown: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    breakdownForDisplay() {
      return this.ratingsBreakdown.sort((a, b) => b.rating - a.rating)
        .map((item) => {
          const percentage = (item.num / this.total)
          // only going to apply a filter if this item has reviews and the overall total is
          // at least 3
          const isFilterable = this.total >= MIN_REVIEWS_FOR_FILTERING && item.num > 0
          return {
            isFilterable,
            num: item.num,
            progressWidth: `${(percentage * 100).toFixed(1)}%`,
            pctOfRatingsFormatted: item.pctOfRatingsFormatted,
            rating: item.rating
          }
        })
    },
    total() {
      return this.ratingsBreakdown.reduce((acc, curr) => acc + curr.num, 0)
    }
  },
  methods: {
    ratingSelected(ratingData) {
      if (!ratingData || !ratingData.isFilterable) {
        return
      }
      // If the reviews list is present, this will apply the star rating to the filter
      const ratingsFilter = (reviewsSummaryConfig as IReviewsSummaryConfig).ratingsFilter
      const filterOptions = ratingsFilter.options.filter((option) => {
        return option.value === ratingData.rating
      })
      this.reviewsStore.filterStore.setFilter(
        ratingsFilter.group,
        ratingsFilter.name,
        filterOptions
      )
    }
  }
}))



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/components/reviews-summary/ratings-breakdown.ts